module.exports = __webpack_public_path__ + "assets/img/contentBj1.b2c13edc.png";